module.exports = __webpack_public_path__ + "img/docs-icon.f4769827.svg";